import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService } from 'api';

export const deleteAccountRequest = createAsyncThunk(
	'userSettings/deleteAccountRequest',
	async () => {
		return await AccountService.deleteAccountRequest();
	},
);
